// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var Condition$ReactHooksTemplate = require("./Condition.res.js");

function empty(param) {
  return "Empty";
}

function path(t) {
  if (typeof t !== "object") {
    return /* [] */0;
  } else {
    return t._2;
  }
}

function setPath(path, t) {
  if (typeof t !== "object") {
    return t;
  } else {
    return {
            TAG: "Graph",
            _0: t._0,
            _1: t._1,
            _2: path
          };
  }
}

function addQuestionToPath(question, graph) {
  if (Question$ReactHooksTemplate.answered(question) && typeof graph === "object") {
    return {
            TAG: "Graph",
            _0: graph._0,
            _1: graph._1,
            _2: Belt_List.concat(Belt_List.keep(graph._2, (function (q) {
                        return !Question$ReactHooksTemplate.equals(q, question);
                      })), {
                  hd: question,
                  tl: /* [] */0
                })
          };
  } else {
    return graph;
  }
}

function removeQuestionFromPath(question, graph) {
  if (typeof graph !== "object") {
    return graph;
  } else {
    return {
            TAG: "Graph",
            _0: graph._0,
            _1: graph._1,
            _2: List.filter(function (q) {
                    return !Question$ReactHooksTemplate.equals(q, question);
                  })(graph._2)
          };
  }
}

function addNode(node, graph) {
  if (typeof graph !== "object") {
    return {
            TAG: "Graph",
            _0: {
              hd: node,
              tl: /* [] */0
            },
            _1: /* [] */0,
            _2: /* [] */0
          };
  } else {
    return {
            TAG: "Graph",
            _0: {
              hd: node,
              tl: graph._0
            },
            _1: graph._1,
            _2: graph._2
          };
  }
}

function addEdge(edge, graph) {
  if (typeof graph !== "object") {
    return "Empty";
  } else {
    return {
            TAG: "Graph",
            _0: graph._0,
            _1: {
              hd: edge,
              tl: graph._1
            },
            _2: graph._2
          };
  }
}

function getEdges(node, graph) {
  if (typeof graph !== "object") {
    return /* [] */0;
  } else {
    return List.filter(function (x) {
                  return Question$ReactHooksTemplate.equals(node, x._0);
                })(graph._1);
  }
}

function removeEdgeForNode(from_, graph) {
  if (typeof graph !== "object") {
    return "Empty";
  }
  var edges = graph._1;
  var nodes = graph._0;
  if (edges) {
    return {
            TAG: "Graph",
            _0: nodes,
            _1: List.filter(function (x) {
                    switch (x.TAG) {
                      case "DefaultLogic" :
                          return !Question$ReactHooksTemplate.equals(from_, x._0);
                      case "SkipLogic" :
                      case "JumpTo" :
                          return true;
                      
                    }
                  })(edges),
            _2: graph._2
          };
  } else {
    return {
            TAG: "Graph",
            _0: nodes,
            _1: /* [] */0,
            _2: graph._2
          };
  }
}

function changeEdge(from, edge, graph) {
  return addEdge(edge, removeEdgeForNode(from, graph));
}

function getNextNode(from, graph) {
  if (typeof graph !== "object") {
    return ;
  } else {
    return Belt_List.head(List.fold_left((function (nextNodes, x) {
                      switch (x.TAG) {
                        case "DefaultLogic" :
                            var to_ = x._1;
                            if (to_.TAG === "ThankYou" || !Question$ReactHooksTemplate.equals(x._0, from)) {
                              return nextNodes;
                            } else {
                              return {
                                      hd: to_,
                                      tl: nextNodes
                                    };
                            }
                        case "SkipLogic" :
                            var to_$1 = x._1;
                            if (!(Question$ReactHooksTemplate.equals(x._0, from) && List.fold_left((function (a, x) {
                                        if (Condition$ReactHooksTemplate.isValid(x)) {
                                          return a;
                                        } else {
                                          return false;
                                        }
                                      }), true, x._2))) {
                              return nextNodes;
                            }
                            if (to_$1.TAG === "ThankYou") {
                              return /* [] */0;
                            }
                            var x$1 = getNextNode(to_$1._0, graph);
                            if (x$1 !== undefined) {
                              return {
                                      hd: x$1,
                                      tl: nextNodes
                                    };
                            } else {
                              return /* [] */0;
                            }
                        case "JumpTo" :
                            if (Question$ReactHooksTemplate.equals(x._0, from) && List.fold_left((function (a, x) {
                                      return Condition$ReactHooksTemplate.isValid(x) ? a : false;
                                    }), true, x._2)) {
                              return {
                                      hd: x._1,
                                      tl: nextNodes
                                    };
                            } else {
                              return nextNodes;
                            }
                        
                      }
                    }), /* [] */0, graph._1));
  }
}

function getPrevNode(to_, graph) {
  if (typeof graph !== "object") {
    return ;
  } else {
    return Belt_List.head(List.fold_left((function (nextNodes, x) {
                      switch (x.TAG) {
                        case "DefaultLogic" :
                            var to__ = x._1;
                            if (to__.TAG === "ThankYou" || !Question$ReactHooksTemplate.equals(to_, to__._0)) {
                              return nextNodes;
                            } else {
                              return {
                                      hd: {
                                        TAG: "Question",
                                        _0: x._0
                                      },
                                      tl: nextNodes
                                    };
                            }
                        case "SkipLogic" :
                            var to__$1 = x._1;
                            if (to__$1.TAG === "ThankYou") {
                              return nextNodes;
                            }
                            if (!(Question$ReactHooksTemplate.equals(to_, to__$1._0) && List.fold_left((function (a, x) {
                                        if (Condition$ReactHooksTemplate.isValid(x)) {
                                          return a;
                                        } else {
                                          return false;
                                        }
                                      }), true, x._2))) {
                              return nextNodes;
                            }
                            var x$1 = getPrevNode(x._0, graph);
                            if (x$1 !== undefined) {
                              return {
                                      hd: x$1,
                                      tl: nextNodes
                                    };
                            } else {
                              return nextNodes;
                            }
                        case "JumpTo" :
                            var to__$2 = x._1;
                            if (to__$2.TAG === "ThankYou" || !(Question$ReactHooksTemplate.equals(to_, to__$2._0) && List.fold_left((function (a, x) {
                                        return Condition$ReactHooksTemplate.isValid(x) ? a : false;
                                      }), true, x._2))) {
                              return nextNodes;
                            } else {
                              return {
                                      hd: {
                                        TAG: "Question",
                                        _0: x._0
                                      },
                                      tl: nextNodes
                                    };
                            }
                        
                      }
                    }), /* [] */0, graph._1));
  }
}

exports.addNode = addNode;
exports.empty = empty;
exports.addEdge = addEdge;
exports.getEdges = getEdges;
exports.path = path;
exports.setPath = setPath;
exports.changeEdge = changeEdge;
exports.getNextNode = getNextNode;
exports.getPrevNode = getPrevNode;
exports.addQuestionToPath = addQuestionToPath;
exports.removeQuestionFromPath = removeQuestionFromPath;
/* Question-ReactHooksTemplate Not a pure module */
